
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/node--figure",
      function () {
        return require("private-next-pages/node--figure/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/node--figure"])
      });
    }
  